import { types } from '~/utils/typeCreator'

export default types(['CLEAR_STATE'], 'NOTICE')
